import React from "react"
import { StyleSheet, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { theme } from "@common/theme/theme"

/** Le pictogramme d'une ligne de la réservation, dans son rond pâle. */
const IconDisc = ({ name }) => (
    <View style={styles.disc}>
        <FontAwesome5 name={name} size={14} color={theme.colors.primary} />
    </View>
)

const styles = StyleSheet.create({
    disc: {
        width: 34,
        height: 34,
        borderRadius: 17,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.colors.linkLighter,
    },
})

export default IconDisc
